<table class="table whitetable">
  <thead>
    <tr>
      <th colspan="3">{{tableName}}</th>
    </tr>
    <tr>
      <th>Stück bis</th>
      <th>%</th>
      <th>Stück</th>
    </tr>
  </thead>
  <tbody>
    @for (obj of deliveryConditionList; track obj) {
      <tr>
        <td>{{ obj.quantity_till|money }}</td>
        <td>{{ obj.percent|money }}</td>
        <td>{{ obj.quantity|money }}</td>
      </tr>
    }
  </tbody>
</table>
